import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IEpRadioButtonData } from '@epicor/kinetic';
import { EpbtFaLabelsService } from '../../services/epbt-fa-labels.service';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { LabelsPrintingMode } from 'ep-bt-controls';
import { UserOption, Branch, LabelsRequest, LabelsRequestPrintingMode, UserOptionOptionType, WebTrackUser } from 'ep-bt-field-agent-proxy';
import { EpbtFaLabelTemplatesGridComponent } from './../epbt-fa-label-templates-grid/epbt-fa-label-templates-grid.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-label-request',
  templateUrl: './epbt-fa-label-request.component.html',
  styleUrls: ['./epbt-fa-label-request.component.scss']
})
export class EpbtFaLabelRequestComponent implements OnInit, AfterViewInit {

  selectedBranchId: number;
  labelRequestForm: FormGroup;
  submitted = false;
  public webTrackUser: WebTrackUser;
  public printingModeData: Array<IEpRadioButtonData> =
  [
    { value: LabelsPrintingMode.Batch, label: 'Batch' },
    { value: LabelsPrintingMode.OnDemand, label: 'On Demand' }
  ];
  sourceLabel = 'Branch';
  selectedPrintingMode: number;

  @ViewChild(EpbtFaLabelTemplatesGridComponent, { static: false }) epbtFaLabelTemplatesGridComponent: EpbtFaLabelTemplatesGridComponent;

  constructor(private faService: EpbtFieldAgentService, private formBuilder: FormBuilder, private labelService: EpbtFaLabelsService) { }

  ngOnInit() {

    if (!this.labelService.labelsRequest) {
      this.labelService.labelsRequest = new LabelsRequest();
    }
    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      this.labelService.labelsRequest.branch = this.labelService.labelsRequest.branch ? this.labelService.labelsRequest.branch : this.webTrackUser.bisTrackBranch;
      this.selectedBranchId = this.labelService.labelsRequest.branch.branchID;
      this.labelService.labelsRequest.printingMode =
        this.labelService.labelsRequest.printingMode == LabelsRequestPrintingMode.OnDemand ? LabelsRequestPrintingMode.OnDemand : LabelsRequestPrintingMode.Batch;

      // this.labelService.getUserOptions(this.webTrackUser.bisTrackUserId, (userOptions) => {
      //   let printModeOption = userOptions.find(option => option.optionKey == "BTCloud:LabelPrintMode" && option.userID == this.webTrackUser.bisTrackUserId)
      //   if (printModeOption) {
      //     this.selectedPrintingMode = printModeOption.optionValue == "0" ? LabelsPrintingMode.Batch : LabelsPrintingMode.OnDemand;
      //   }
      //   else {
      //     // by default we use batch mode
      //     this.selectedPrintingMode = LabelsPrintingMode.Batch;
      //   }
      //   this.labelService.labelsRequest.printingMode = this.selectedPrintingMode == LabelsPrintingMode.Batch ? LabelsRequestPrintingMode.Batch : LabelsRequestPrintingMode.OnDemand;
      // });
    });


    this.labelRequestForm = this.formBuilder.group({
      // printingMode: ['']
    });

    // if (this.labelService.labelsRequest.branch)
    //   this.selectedBranchId = this.labelService.labelsRequest.branch.branchID;

    this.labelService.labelRequestFormFlag = this.labelRequestForm.valid;

    this.labelRequestForm.valueChanges.subscribe(
      result => {
        this.validateForm();
      });
  }

  ngAfterViewInit() {
    // if (this.labelService.labelsRequest) {
    //   this.labelRequestForm.patchValue({
    //     printingMode: this.labelService.labelsRequest.printingMode == LabelsRequestPrintingMode.Batch ? LabelsPrintingMode.Batch : LabelsPrintingMode.OnDemand,
    //   });
    //   this.selectedPrintingMode = this.labelService.labelsRequest.printingMode == LabelsRequestPrintingMode.Batch ? LabelsPrintingMode.Batch : LabelsPrintingMode.OnDemand;
    // }
    this.labelService.labelRequestFormFlag = this.labelRequestForm.valid;
  }

  get frmFields() { return this.labelRequestForm.controls; }

  validateForm() {
    if (this.labelRequestForm.valid && this.selectedBranchId > 0) {
      this.labelService.labelRequestFormFlag = this.labelRequestForm.valid;
    } else {
      this.labelService.labelRequestFormFlag = false;
    }
  }

  onLabelRequestSubmit() {

    this.submitted = true;
    if (this.labelRequestForm.valid && this.selectedBranchId > 0 && this.checkTemplatesQuantity()) {
      this.labelService.labelRequestFormFlag = true;
    } else {
      this.labelService.labelRequestFormFlag = false;
      return;
    }

  }

  checkTemplatesQuantity(): boolean {
    let flag = true;
    if (this.labelService.labelsRequest.templates && this.labelService.labelsRequest.templates.length > 0) {
      const maxIndex = this.labelService.labelsRequest.templates.findIndex(item => item.requestedQuantity > 99999);
      const minIndex = this.labelService.labelsRequest.templates.findIndex(item => item.requestedQuantity > 0);
      if (maxIndex != -1 || minIndex == -1) {
        flag = false;
      }
    }
    return flag;
  }

  onBranchValueChange(selectedBranch: Branch) {
    if (selectedBranch) {
      if (!this.labelService.labelsRequest.branch) {
        this.labelService.labelsRequest.branch = selectedBranch;
      } else {
        const previousBranchId = this.labelService.labelsRequest.branch.branchID;
        this.labelService.labelsRequest.branch = selectedBranch;
        if (selectedBranch.branchID != previousBranchId) {
          // after recent discussions with kevin, no need to clear products on branch change, so commenting below code
          // if (this.labelService.labelsRequest.products)
          //   this.labelService.labelsRequest.products.length = 0;
          // this.labelService.labelsRequest.printingMode = LabelsRequestPrintingMode.Batch;
          // this.faService.getBisTrackSetting((bisTrackSettings: any) => {
          //   this.epbtFaLabelTemplatesGridComponent.bindLabelTemplates(bisTrackSettings.branchPrinters);
          // });
          // this.labelService.productsCount = 0;
        }
      }
      this.selectedBranchId = selectedBranch.branchID;
      this.validateForm();
    }
  }

  // onPrintingModeSelectionChange(printMode) {
  //   this.selectedPrintingMode = parseInt(printMode);
  //   this.labelService.labelsRequest.printingMode = this.selectedPrintingMode == LabelsPrintingMode.Batch ? LabelsRequestPrintingMode.Batch : LabelsRequestPrintingMode.OnDemand;
  //   let userOption = new UserOption();
  //   userOption.userID = this.labelService.webTrackUser.bisTrackUserId;
  //   userOption.optionType = UserOptionOptionType.UotMiscFormSettings;
  //   userOption.optionKey = "BTCloud:LabelPrintMode";
  //   userOption.optionValue = printMode;
  //   this.labelService.setUserOptions(userOption, (res) => {
  //   });
  // }

}
